export const defaultContactInformation = [
  { label: 'Emergency Crisis Line', value: '0800 955 6222', href: 'tel:+448009556222' },
  { label: 'General Enquiries', value: '03300 414 996', href: 'tel:+443300414996' },
  { label: 'Email', value: 'contactus@rradar.com', href: 'mailto:contactus@rradar.com' },
  { label: 'Legal/Policy Queries', value: '0800 955 6111', href: 'tel:+448009556111' },
];

export const parseContactInformation = (content) => {
  const contacts = content.split(',').map((item) => {
    // Default to '' so an item without ':' (e.g. a trailing comma) is filtered out instead of throwing.
    const [label, value = ''] = item.split(':').map((part) => part.trim());

    const isEmail = value.includes('@');

    return {
      label,
      value,
      href: isEmail ? `mailto:${value}` : `tel:+44${value.replace(/\s+/g, '').replace(/^0/, '')}`,
    };
  });

  return contacts.filter(({ value }) => value);
};

export const getContactInformation = (user = {}) => {
  // Report returns the current company/application scope on the AMS actor.
  const contactOverride = user.actor?.scope?.features?.CONTACT_DETAILS_OVERRIDE?.value?.[0];
  const contacts = contactOverride ? parseContactInformation(contactOverride) : [];
  // Fall back to the standard rradar contacts when no override is set or it has no usable entries.
  return contacts.length ? contacts : defaultContactInformation;
};
